export const CTFlags = {
  DAMAGE: 1 << 0,
  DAMAGE_CRIT: 1 << 1,
  HEAL: 1 << 2,
  HEAL_CRIT: 1 << 3,
  INFO: 1 << 4,
}
